import 'css-chunk:src/feature/flip-and-tip/FlipAndTipReceiptToast.module.scss';export default {
  "root": "FlipAndTipReceiptToast_root"
};